import { memo } from 'react';
import { COLORS } from '@/game/configs';
interface CellProps {
  value: number | null;
  notes: number[];
  isGiven: boolean;
  isSelected: boolean;
  isHighlighted: boolean;
  isError: boolean;
  onClick: () => void;
}
export const Cell = memo(function Cell({
  value,
  notes,
  isGiven,
  isSelected,
  isHighlighted,
  isError,
  onClick,
}: CellProps) {
  const getBackgroundColor = () => {
    if (isSelected) return COLORS.yellow;
    if (isError) return '#FEE2E2';
    if (isHighlighted) return '#FAF0E6';
    return COLORS.cream;
  };
  const getTextColor = () => {
    if (isError) return '#DC2626';
    if (isGiven) return COLORS.dark;
    return '#4A5568';
  };
  return (
    <button
      onClick={onClick}
      className="relative flex items-center justify-center w-full aspect-square rounded-lg transition-all duration-150 cursor-pointer"
      style={{
        backgroundColor: getBackgroundColor(),
        boxShadow: isSelected
          ? '0 4px 8px rgba(139, 115, 85, 0.3)'
          : '0 2px 4px rgba(139, 115, 85, 0.1)',
      }}
    >
      {value !== null ? (
        <span
          className="font-bold text-lg sm:text-xl"
          style={{ color: getTextColor() }}
        >
          {value}
        </span>
      ) : notes.length > 0 ? (
        <div className="grid grid-cols-3 grid-rows-3 gap-px w-full h-full p-1">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <span
              key={num}
              className="flex items-center justify-center text-[8px] sm:text-[10px] font-semibold"
              style={{ color: getTextColor() }}
            >
              {notes.includes(num) ? num : ''}
            </span>
          ))}
        </div>
      ) : null}
    </button>
  );
});